export { EstatePlanningRecommendationBuyStepTemplate, TaxFilingPurchaseTemplate } from './Template';
